<template>
  <div>
    <v-alert
      outlined
      :color="color"
      text
      class="mb-0 rounded-b-0 font-weight-regular py-3 rounded-md"
    >
      <div style="font-size: 16px; min-height: 44px;" class="d-flex align-center w-100">
        <slot name="title"></slot>
      </div>
    </v-alert>
    <div class="rounded-b" :style="`border: 1px solid var(--v-${color}-base); border-top: none;`">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    color: String
  }
}
</script>